export const personalInformation = {
    SuccessMessages: {
        PERSONAL_INFO_REGISTERED_MSG: "個人情報登録が正常に完了しました。",
        PERSONAL_INFO_UPDATED_MSG: "個人情報更新が正常に完了しました。",
        PERSONAL_INFO_DELETED_MSG: "個人情報削除が正常に完了しました。",
        PHONE_VALID: "11桁の電話番号を入力してください。",
        URL_VALID: "資格者証写真URLを入力してください。",
        FACEURL_VALID: "顔写真URLを入力してください。",
        NO_IMAGE_SELECTED: "画像が選択されていません。",
        SEARCH: "氏名・性別・住所などで検索",
        NUM_OF_IMAGES_SELECTED: "枚の画像を選択しました。"
    },
    ErrorMessages: {
        PHONENUMBER_VALID_ERR: "有効な電話番号を入力してください",
        BOT_DETECTION_ERR: "ボット検出に失敗しました。再度チェックしてください",
        COMMUNICATION_ERR: "通信に失敗しました。再度お試しください",
        REGISTRATION_ERR: "登録に失敗しました。しばらく経ってから再度お試しください"
    },
    Labels: {
        PERSONAL_INFO_SCREEN: "個人情報が正常",
        NAME: "氏名",
        DATEOFBIRTH: "生年月日",
        GENDER: "性別",
        ADDRESS: "住所",
        PHONENUMBER: "電話番号",
        EMERGENCY_PHONENUMBER_LBL: "緊急連絡先",
        EMERGENCY_NAME: "連絡先氏名",
        EMERGENCY_RELATION: "連絡先関係",
        PARTNER_COMPANY: "所属取引先",
        IS_SOLE_PROPRIETOR: "１人親方かどうか",
        SPECIAL_LABOR_INSURANCE: "労災の特別加入",
        BLOOD_TYPE: "血液型",
        HEALTH_CHECK_DATE: "直近の健康診断日",
        JOB_TYPE: "職種",
        QUALIFICATIONS: "保有資格",
        QUALIFICATION_EXPIRY: "資格期限",
        QUALIFICATION_PHOTO_LBL: "資格者証写真",
        FACE_PHOTOS_LBL: "顔写真",
        ACTION: "アクション",
        YES_OPTION: "はい",
        NO_OPTION: "いいえ",
        BASIC_INFO_LBL: "基本情報",
        HEALTH_INFO_LBL: "健康情報",
        OCCUPATION_INFO_LBL: "職業情報",
        REGISTRATION_SUCC_TITLE: "情報登録成功",
        UPDATE_SUCC_TITLE: "情報更新成功",
        REGISTRATION_ERR_TITLE: "情報登録失敗",
        UPLOAD_BTN: "アップロード",
        PARTNER_COMPANY_LBL :"所属取引先", 
        CLEAR_BTN: "クリア",
        LIST: "作業員一覧",
        DETAILS: "個人情報",
        EDIT: "個人情報",
        ADD: "個人情報"
    }
}